import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

const Cart = () => {
    let [products,setProducts]=useState([
        {
            sno:"ILT001",
            name:"MI",
            img:"https://cdn1.ethoswatches.com/media/catalog/product/cache/6e5de5bc3d185d8179cdc7258143f41a/f/a/favre-leuba-deep-blue-renaissance-00-20308-101-02-200-large_1.jpg",
            price:1000,
            qty:3
        },
        {
            sno:"ILT002",
            name:"Samsung",
            img:"https://cdn1.ethoswatches.com/media/catalog/product/cache/6e5de5bc3d185d8179cdc7258143f41a/f/a/favre-leuba-chief-00-10201-08-21-44-large.jpg",
            price:999,
            qty:1
        },
        {
            sno:"ILT003",
            name:"Titon",
            img:"https://cdn1.ethoswatches.com/media/catalog/product/cache/6e5de5bc3d185d8179cdc7258143f41a/f/a/favre-leuba-sea-sky-revival-00-20212-112-01-101-large_1.jpg",
            price:800,
            qty:1
        },
        {
            sno:"ILT004",
            name:"Daniel Klein",
            img:"https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcQUXKPT2_RDmKCTQKXPDcaNyGCvqelbPV1xnZdLAN_QWPKohuPOOIS2HExudcW0_CSF6sDU1lN-iy5LRQkyiE3X65NCiBcgDhcf7A67plGLtWTZWyYFH6Aa",
            price:2600,
            qty:1
        },
        {
            sno:"ILT005",
            name:"Fastrack",
            img:"https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcTdILLW_bpzDGhs1np2U7zAewAlakbzrUNaPjacGtVZkivIAGUG6MPv59PM4Qtzmgy1zzsw66b-MvHJrY3zvJEnkCHj07O3BktZ70C3pTRXTjeLnLXG8qX5",
            price:4000,
            qty:1
        },
        {
            sno:"ILT006",
            name:"Casio",
            img:"https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcSey6bv29eA-KXxFgUC51jAda92by9AKS8l4cBR2RIvBmRNFujghtxxBcHvMlWWaE0aajY-_gsTZ_O3DpETPDs2urDPwkTGmds-UmNute-798uI7kBrNksY-2U",
            price:1500,
            qty:1
        }
    ])


    let inc1=(productId)=>{
        console.log(productId)
        let item = products.map(product=>{
            if(product.sno === productId){
                return{
                    ...product,
                    qty: product.qty +1
                }
            }
            return product
        })

        setProducts(...item)

    }

    let dec1=(productId)=>{
        console.log(productId)
        let item = products.map(product=>{
            if(product.sno === productId){
                return{
                    ...product,
                    qty: product.qty - 1 > 0 ? product.qty-1 : 1
                }
            }
            return product
        })

        setProducts(...item)

    }

    let totalPrice = ()=>{
        let total = 0
        for(let product of products){
            total += product.qty * product.price
        }
        return total
    }
  return (
    <>
      <Header />
        <div className="container">
            <div className="table-responsive mt-5">
                <table className="table table-bordered table-dark">
                    <thead>
                        <tr>
                            <th>Sno</th>
                            <th>Name</th>
                            <th>Image</th>
                            <th>Price</th>
                            <th>Qty</th>
                            <th>Total</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        {
                            products.map((product,index)=>{
                                return(
                                    <tr key={index}>
                                        <td>{product.sno}</td>
                                        <td>{product.name}</td>
                                        <td><img src={product.img} alt="" style={{width:"50px",height:"50px"}} /></td>
                                        <td>{product.price}</td>
                                        <td className='text-center'>
                                            <i class="fa-solid fa-square-minus me-2" onClick={()=>dec1(product.sno)}></i>
                                            {product.qty}
                                            <i class="fa-solid fa-square-plus ms-2" onClick={()=>inc1(product.sno)}></i>
                                        </td>
                                        <td>{product.price * product.qty}</td>
                                    </tr>
                                )
                            })
                        }

                        <tr>
                            <td colSpan={5}>
                                <h3>Total Price</h3>
                            </td>
                            <td>{totalPrice()}</td>
                        </tr>
                        <tr>
                            <td colSpan={5}>
                                
                            </td>
                            <td>
                                <button className='btn btn-danger'>Place Order</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      <Footer />
    </>
  )
}

export default Cart
